import React, { useRef } from 'react';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { FormattedNumber } from 'react-intl';
import './PrintPaymentPlanSummary.css';

interface Props {
    PageData?: any;
    Model?: any;
}
export const PrintPaymentPlanSummary = React.forwardRef(
    ({ PageData, Model }: Props, ref: any) => {
    const LOGO_ICONS_PATH = `${process.env.PUBLIC_URL}/images/logo/`;
    const hoistLogo = `${LOGO_ICONS_PATH}/hoist_logo_color.svg`;

        return (
            <div ref={ref}>
            <div id="container">
                <header>
                    <img className="logo" src={hoistLogo} width="272" />
                </header>

                {(Model?.IsSummaryDetailsHeaderVisible) &&
                    (
                        <>{PageData?.ThankYou}
                            <span></span>
                            {PageData?.PanelHeader}
                        </>
                    )}

                {(Model?.IsPaymentPendingInfoVisible) &&
                    (
                        <>
                            <br />
                            <h3>{PageData?.AdyenPaymentPending}</h3>
                        </>
                    )}

                <h3>{PageData?.PaymentPlanTableHeader}</h3>
                <table>
                    <tbody>
                        {(!isNullOrWhiteSpace(Model.AccountLegacyId)) &&
                            (
                                <tr>
                                    <td className="header bold">{PageData?.AccountLegacyIdLabel}</td>
                                    <td className="value">{Model?.AccountLegacyId}</td>
                                </tr>
                            )}
                        <tr className={(Model.DiscountedDebtBalance > 0 ? " strikethrough" : "")}>
                            <td className="header bold">{PageData?.DebtBalance}</td>
                            <td className="value">                                
                            {Model?.FormattedCurrencyDebtBalance}

                            </td>
                        </tr>
                        {(Model.IsDiscountedDebtBalanceVisible) &&
                            (
                                <tr>
                                    <td className="header bold">{PageData?.DiscountedDebtBalance}</td>
                                    <td className="value">                                        
                                        {Model?.FormattedCurrencyDiscountedDebtBalance}
                                    </td>
                                </tr>
                            )}
                        {(Model.FirstPaymentValue > 0) &&
                            (
                                <tr>
                                    <td className="header bold">{PageData?.FirstPaymentValueLabel}</td>
                                    <td className="value">                                       
                                        {Model?.FormattedCurrencyFirstPayment}
                                    </td>
                                </tr>
                            )}
                        <tr>
                            <td className="header bold">{PageData.RegularPaymentValueLabel} </td>
                            <td className="value">                               
                                {Model.FormattedCurrencyRegularPayment}
                            </td>
                        </tr>
                        {(Model.LastPaymentValue > 0) &&
                            (
                                <tr>
                                    <td className="header bold">{PageData?.LastPaymentValueLabel}</td>
                                    <td className="value">                                        
                                        {Model.FormattedCurrencyLastPayment}
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
                <hr />
                <h3>{PageData?.PaymentsDetailsTableHeader}</h3>
                <table>
                    <tbody>
                        <tr>
                            <td className="header">{PageData?.PaymentMethod}</td>
                            <td className="value">{Model?.PaymentMethodName}</td>
                        </tr>

                        {(Model.IsTabRowWithExternalPaymentReferenceVisible) &&
                            (
                                <tr>
                                    <td className="header">{PageData?.ExternalPaymentReference}</td>
                                    <td className="value">{Model?.ExternalPaymentReference}</td>
                                </tr>
                            )}

                        <tr>
                            <td className="header">{PageData?.FirstPayment}</td>
                            <td className="value">{Model?.FirstPayment}</td>
                        </tr>
                        <tr>
                            <td className="header">{PageData?.LastPayment}</td>
                            <td className="value">{Model?.LastPayment}</td>
                        </tr>

                        {(Model?.IsBankAccoutNumberVisible) &&
                            (
                                <>
                                    {(!isNullOrWhiteSpace(Model.BankSortCode)) &&
                                        (
                                            <tr>
                                                <td className="header">{PageData?.BankSortCode}</td>
                                                <td className="value">{Model?.BankSortCode}</td>
                                            </tr>
                                        )}
                                    < tr >
                                        <td className="header">{PageData?.BankAccountNumber}</td>
                                        <td className="value">{Model?.BankAccountNumber}</td>
                                    </tr>
                                </>
                            )}
                    </tbody>
                </table>
            </div >
            </div>
        );
    },
);